import { render } from "./openapi-doc.vue?vue&type=template&id=f78e7970&scoped=true"
import script from "./openapi-doc.vue?vue&type=script&lang=js"
export * from "./openapi-doc.vue?vue&type=script&lang=js"

import "./openapi-doc.vue?vue&type=style&index=0&id=f78e7970&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f78e7970"]])

export default __exports__